import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

export const PersonalizableChip: FC<ChipProps> = ({ className }) => {
  const { t } = useTranslation()
  return (
    <Chip className={className} color="greyV3" size="small">
      {t('common:PERSONALISABLE_PRODUCT_TAG', 'Personalisable')}
    </Chip>
  )
}
